import { render, staticRenderFns } from "./ButtonReadMore.vue?vue&type=template&id=7474b2dc"
import script from "./ButtonReadMore.vue?vue&type=script&lang=js"
export * from "./ButtonReadMore.vue?vue&type=script&lang=js"
import style0 from "./ButtonReadMore.vue?vue&type=style&index=0&id=7474b2dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports